"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSYStake = void 0;
const Decimal_1 = require("./Decimal");
/**
 * Represents a user's PSY stake and accrued gains.
 *
 * @remarks
 * Returned by the {@link ReadableLiquity.getPSYStake | getPSYStake()} function.

 * @public
 */
class PSYStake {
    /** @internal */
    constructor(stakedPSY = Decimal_1.Decimal.ZERO, collateralGain = Decimal_1.Decimal.ZERO, slsdGain = Decimal_1.Decimal.ZERO) {
        this.stakedPSY = stakedPSY;
        this.collateralGain = collateralGain;
        this.slsdGain = slsdGain;
    }
    get isEmpty() {
        return this.stakedPSY.isZero && this.collateralGain.isZero && this.slsdGain.isZero;
    }
    /** @internal */
    toString() {
        return (`{ stakedPSY: ${this.stakedPSY}` +
            `, collateralGain: ${this.collateralGain}` +
            `, slsdGain: ${this.slsdGain} }`);
    }
    /**
     * Compare to another instance of `PSYStake`.
     */
    equals(that) {
        return (this.stakedPSY.eq(that.stakedPSY) &&
            this.collateralGain.eq(that.collateralGain) &&
            this.slsdGain.eq(that.slsdGain));
    }
    /**
     * Calculate the difference between this `PSYStake` and `thatStakedPSY`.
     *
     * @returns An object representing the change, or `undefined` if the staked amounts are equal.
     */
    whatChanged(thatStakedPSY) {
        thatStakedPSY = Decimal_1.Decimal.from(thatStakedPSY);
        if (thatStakedPSY.lt(this.stakedPSY)) {
            return {
                unstakePSY: this.stakedPSY.sub(thatStakedPSY),
                unstakeAllPSY: thatStakedPSY.isZero
            };
        }
        if (thatStakedPSY.gt(this.stakedPSY)) {
            return { stakePSY: thatStakedPSY.sub(this.stakedPSY) };
        }
    }
    /**
     * Apply a {@link PSYStakeChange} to this `PSYStake`.
     *
     * @returns The new staked PSY amount.
     */
    apply(change) {
        if (!change) {
            return this.stakedPSY;
        }
        if (change.unstakePSY !== undefined) {
            return change.unstakeAllPSY || this.stakedPSY.lte(change.unstakePSY)
                ? Decimal_1.Decimal.ZERO
                : this.stakedPSY.sub(change.unstakePSY);
        }
        else {
            return this.stakedPSY.add(change.stakePSY);
        }
    }
}
exports.PSYStake = PSYStake;
//# sourceMappingURL=PSYStake.js.map